import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'monitoring',
  },
  {
    path: 'monitoring',
    title: 'Monitoring',
    loadComponent: () => import('./components/monitoring/monitoring.component').then(m => m.MonitoringComponent),
  },
  // {
  //   path: 'events',
  //   title: 'Events',
  //   loadComponent: () => import('./components/event/event.component').then(m => m.EventComponent),
  // },
  // {
  //   path: 'calls',
  //   title: 'Calls',
  //   loadComponent: () => import('./components/call/call.component').then(m => m.CallComponent),
  // }
];
